import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Box, Grid, IconButton, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Images from '../../../../Assets/assetHelper';
import { getDeals } from '../../../../Utils/apiService';
import { truncateText } from '../../../../Utils/helperFunctions';
import routes from '../../../../Utils/routes';
import { DealsInterface } from '../../../../interfaces/Deals';
import { useStyles } from '../styles';
import KenLoader from '../../../../GlobalComponents/KenLoader';

const ViewALLOffers = () => {
  const classes = useStyles();
  const [data, setData] = useState<DealsInterface[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    Promise.all([getDeals()])
      .then(async ([dealsRes]) => {
        if (dealsRes.status === 'true') {
          setData(dealsRes.result);
        }

        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <Paper className={classes.paperContainer}>
          <Box>
            <Typography sx={{ fontSize: { xs: '15px', ultraHD: '20px' }, fontWeight: '500', mb: { xs: '18px', ultraHD: '24px' } }}>Offers</Typography>
            <Box>
              <Grid container spacing={2} sx={{ pr: { xs: '0px', md: '18px', ultraHD: '24px' }, pb: '10px', height: '94%', overflow: 'auto' }}>
                {data?.map((item, index) => (
                  <Grid item xs={6} sm={4} md={6} lg={4} xxl={3} key={index}>
                    <Box className={classes.cardContainer} onClick={() => navigate(`${routes.dealsDetails}/${item.provider}`, { state: { data: item, breadCrumbs: item.provider } })}>
                      <Box className={classes.cardSubContainer}>
                        <Box component="img" src={item.image ?? Images.Images.DefaultOrganizationLogo} alt={item.provider} className={classes.cardImg} />
                        <Typography className={classes.cardHeader}>{item.provider ?? ''}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', flexDirection: 'column', mt: { xs: '6px', ultraHD: '8px' }, width: '100%' }}>
                        <Typography className="dealsDescriptionTypo2" mb={{ xs: '6px', ultraHD: '8px' }}>
                          {truncateText(item.description ?? '', 45)}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box>
                            <Typography className="dealsDescriptionTypo2" mb={{ xs: '3px', ultraHD: '4px' }}>
                              Categories: {item.categories ?? ''}
                            </Typography>
                            <Typography className="dealsDescriptionTypo2">
                              Savings:
                              {item.savings ?? ''}/-
                            </Typography>
                          </Box>
                          <Box>
                            <IconButton>
                              <ArrowForwardOutlinedIcon sx={{ fontSize: '20px', color: '#373A45' }} />
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={6} sm={4} md={6}></Grid>
            </Box>
          </Box>
        </Paper>
      )}
    </>
  );
};

export default ViewALLOffers;
